import { createContext, useContext } from "react";

import type { TriggerDesignsContext } from "./TriggerDesignsContext.ts";

type HandlerDesignerContext = {
  id: number;
  nodeId: number;
  eventTypes: string[];
  getResponses: () => ReturnType<TriggerDesignsContext["getResponses"]>;
  addResponse: () => number;
} & Pick<
  TriggerDesignsContext,
  | "getResponse"
  | "removeResponse"
  | "reorderResponse"
  | "updateResponse"
  | "resolveEffectBuildables"
  | "resolveConditionBuildables"
>;

export const HandlerDesignerContext = createContext<HandlerDesignerContext | undefined>(undefined);

export const useHandlerDesigner = () => {
  const context = useContext(HandlerDesignerContext);
  if (!context) {
    throw new Error(`Expected HandlerDesignerContextProvider in component ancestry.`);
  }
  return context;
};

/**
 * The node whose trigger is being edited, or undefined outside a trigger
 * editor. Scopes value pickers in condition/effect edit forms.
 */
export const useTriggerScopeNodeId = (): number | undefined => useContext(HandlerDesignerContext)?.nodeId;
